<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center margin-right-sm ">
                <span>关键字：</span>
                <el-input style="width: 250px" v-model="keyword" clearable placeholder="请输入关键字"></el-input>
<!--                <template v-if="[3].includes(user.power)">-->
<!--                    <span>社区：</span>-->
<!--                    <el-select v-model="xiangmu_id" clearable filterable placeholder="请选择社区">-->
<!--                        <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </template>-->
                <span>状态：</span>
                <el-select v-model="state" clearable filterable placeholder="请选择状态">
                    <el-option v-for="item in [
                        { name: '全部', id: '' },
                        { name: '已报名', id: 0 },
                        // { name: '已上传佐证', id: 1 },
                        { name: '已签到', id: 2 },
                        // { name: '拒绝报名', id: 3 },
                        { name: '取消报名', id: 4 }
                    ]" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>

                <el-button class="margin-left-xs" type="primary" @click="hanldSearch">搜索</el-button>
                <el-button :loading="export_loading" type="primary" @click="exportData">导出</el-button>
            </div>
            <div class="flex align-center margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>

            </div>

            <el-table :data="residentList" alig="center" border header-row-class-name="table-header"
                row-class-name="table-row" style="width: 100%">
                <el-table-column align="center" label="序号" type="index" width="70"></el-table-column>
                <el-table-column label="所属社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="姓名" prop="user_name"></el-table-column>
                <el-table-column label="手机号" prop="user_phone"></el-table-column>
                <el-table-column label="时间" prop="create_time"></el-table-column>
                <el-table-column label="状态" prop="state_name"></el-table-column>
                <el-table-column label="佐证" width="220">
                    <template slot-scope="scope">
                        <div class="flex flex-wrap" v-if="scope.row.evidence">
                            <el-image :src="scope.row.evidence" :preview-src-list="[scope.row.evidence]"
                                style="width: 100px; height: 100px;">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="270">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <template v-if="scope.row.state === 1 && scope.row.type === 1">
                                <el-button size="small" type="primary" @click="passItem(scope.row.id, 2)">通过
                                </el-button>
                                <el-button size="small" type="primary" @click="passItem(scope.row.id, 3)">拒绝
                                </el-button>
                            </template>
                            <el-button size="small" type="primary" @click="delItem(scope.row.id)">取消报名
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="residentList.length > 0" :current-page.sync="page" :page-size="limit" :total="total"
                background class="page-all" layout="prev, pager, next, jumper" @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {getXiangMuList} from "@/api/common";
import {cancelSign, getActiveSignList, passSign} from "@/api/gzh";
import {upFeil} from "@/config";
import {getToken} from "@/utils/utils";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            FILE_URL: upFeil,
            projectList: [],
            keyword: '',
            activity_id: '',
            xiangmu_id: '',
            state: '', //状态 0已报名 1已上传佐证 2审核通过 3拒绝报名 4取消报名
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
            export_loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
      this.$emit("setIndex", '/home/gzh/teams', "双暖为老 / 队伍管理 / 活动列表", true);
        this.activity_id = this.$route.params.id
        this.getList()
        // this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{ name: '全部', id: 0 }, ...project.data]
        },
        //  获取商品列表
        async getList() {
            let _data = await getActiveSignList(
                this.keyword,
                this.activity_id,
                this.xiangmu_id,
                this.state,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        hanldSearch() {
            this.page = 1
            this.getList()
        },
        passItem(id, state) {
            this.$confirm(`您确定要${state === 2 ? '通过' : '拒绝'}该报名吗？`, "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.passSign(id, state);
            });
        },
        async passSign(id, state) {
            let _state = await passSign(id, state);
            this.getList();
            this.$message.success(_state.info);
        },
        delItem(id) {
            this.$confirm('您确定要取消该报名吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.cancelSign(id);
            });
        },
        async cancelSign(id) {
            let _state = await cancelSign(id);
            this.getList();
            this.$message.success(_state.info);
        },
        async exportData() {
            window.open(`${upFeil}/index/export/exportActivityBaoMing?token=${getToken().token}&activity_id=${this.activity_id}&keyword=${this.keyword}&state=${this.state}&xiangmu_id=${this.xiangmu_id}`)
        },

    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped></style>
